import {Location} from '@angular/common';
import typia from 'typia';

const isHandled = typia.createIs<{readonly homeyPaymentSuccessHandled: true}>();
const isState = typia.createIs<Record<string, unknown>>();

/**
 * True the first time a payment success page is shown in this history entry, and marks the entry
 * so Back, Forward and reload into it return false. The entry is kept rather than replaced: the
 * one before it is the finished Stripe Checkout session, a dead end. Call it from the page's
 * constructor, after the router has written the entry's own state.
 */
export function claimFirstVisit(location: Location): boolean {
  const state = location.getState();
  if (isHandled(state)) {
    return false;
  }
  location.replaceState(location.path(true), '', {...(isState(state) ? state : {}), homeyPaymentSuccessHandled: true});
  return true;
}
